import {Inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {AppConfigService} from "../app-config/app-config.service";
import {Observable} from "rxjs";
import {IVersionDetails} from "./version.details.model";

@Injectable()
export class VersionDetailsService {

    constructor(private http: HttpClient, @Inject(AppConfigService) private _appConfigService: AppConfigService) {
    }

    public getVersionDetails(): Observable<IVersionDetails> {
        const webApiURL = this._appConfigService.getWebapiURL();
        return this.http.get<IVersionDetails>(`${webApiURL}/VersionDetails/GetVersionDetails`);
    }
}
